import axios from "axios";
import * as _ from "lodash";

const HEADER_KEY = 'X-App-Request-Trace-ID'.toLowerCase();

axios.interceptors.request.use(request => {
    let trackingId = Date.now().toString(36).split('').reverse().join('');

    console.debug(`Request sent: 📦 ${trackingId}`, {
        url: request.url,
        request: request,
        data: request.data
    });

    request.headers[HEADER_KEY] = trackingId;

    return request;
});

axios.interceptors.response.use(
    (response) => {
        console.debug(`Response received (OK): ✴️ ${response.headers[HEADER_KEY]}`, {
            url: response.request.responseURL,
            response: response,
            data: _.cloneDeep(response.data)
        });

        return response;
    },
    (error) => {
        console.debug(`Response received (FAILED): 💥 ${error.response.headers[HEADER_KEY]}`, {
            url: error.response.request.responseURL,
            response: error.response,
            data: _.cloneDeep(error.response.data),
        });

        if (error.response.status == 422) {
            let response: {
                message: string
                errors: object
            } = error.response.data;

            console.warn(response.message, response.errors);
        }

        return Promise.reject(error);
    }
);
